import { ReportGmailerrorred as ReportGmailErrorRedIcon } from '@mui/icons-material';

const ReportGmailErrorRed = (): JSX.Element => <ReportGmailErrorRedIcon fontSize="inherit" />;

export default ReportGmailErrorRed;
